import React from 'react';
import { motion } from 'framer-motion';
import { useBooking } from './BookingContext';
export function CTASection() {
  const {
    openBooking
  } = useBooking();
  return <section id="contact" className="py-40 bg-brand-black relative z-10 overflow-hidden" data-id="element-229">
      {/* Subtle brand glow behind section */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-brand-orange/5 rounded-full blur-[150px] pointer-events-none" data-id="element-230" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-231">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-display text-5xl md:text-7xl text-white mb-8 tracking-tight leading-[1.1]" data-id="element-232">
          AI That Actually Works <br className="hidden md:block" data-id="element-233" />
          <span className="text-gray-500" data-id="element-234">in Your Industry.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="font-body text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-16 leading-relaxed" data-id="element-235">
          See how Aijentik can automate workflows, reduce operational drag, and
          unlock industry-specific AI execution inside your business.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col items-center justify-center gap-8" data-id="element-236">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full" data-id="element-237">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={openBooking} className="relative w-full sm:w-auto px-10 py-5 bg-brand-orange hover:bg-brand-deep-orange text-white font-medium rounded-full transition-colors duration-300 text-lg shadow-[0_0_30px_rgba(219,127,74,0.2)] hover:shadow-[0_0_50px_rgba(219,127,74,0.4)] group" data-id="element-238">
              <span className="relative z-10" data-id="element-239">Book a Demo</span>
              <motion.div className="absolute inset-0 rounded-full bg-brand-orange blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300" animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-240" />
            </motion.button>
            <motion.a whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} href="#solutions" className="w-full sm:w-auto px-10 py-5 bg-white/5 border border-white/10 hover:border-white/30 hover:bg-white/10 text-white font-medium rounded-full transition-colors duration-300 text-lg" data-id="element-241">
              Explore Industries
            </motion.a>
          </div>

          <p className="text-sm font-medium text-gray-500 uppercase tracking-widest" data-id="element-242">
            No generic AI. No wasted time. Just execution.
          </p>
        </motion.div>
      </div>
    </section>;
}